/* global localStorage */
import ApiService from '@/common/api.service'
import JwtService from '@/common/jwt.service'
import User from '@/models/User'

import {
    LOGIN,
    LOGOUT,
    CHECK_AUTH,
    RECOVERY_PASS,
    FECTH_AUTH,
    FECTH_USER_ACCESS,
    CHECK_TMP_RECOVERY_TOKEN
} from '@/store/actions.type'
import {
    SET_AUTH,
    PURGE_AUTH,
    SET_ERROR,
    SET_LOCALSTORE,
    SET_USER_ACCESS
} from '@/store/mutations.type'

const state = {
    errors: null,
    user: null,
    isAuthenticated: !!JwtService.getToken(),
    userAccessPlugins: null,
    userAccessTables: null,
    userGestorUsuarios: null
}

const getters = {
    currentUser(state) {
        return state.user
    },
    isAuthenticated(state) {
        return state.isAuthenticated
    },
    isAdmin(state) {
        return state.user.admin
    },
    userAccessPlugins(state) {
        return state.userAccessPlugins
    },
    userAccessTables(state) {
        return state.userAccessTables
    },
    userGestorUsuarios() {
        return state.userGestorUsuarios
    }
}

const mutations = {
    [SET_ERROR](state, error) {
        state.errors = error
    },
    [SET_LOCALSTORE](state, user) {

        state.isAuthenticated = true
        state.user = User.from(user)
        state.errors = {}
        JwtService.saveToken(state.user.token)

        localStorage.setItem('user', JSON.stringify(state.user))
        localStorage.setItem('token', user)

        if (state.user.rol === '1') {
            state.user.admin = true
        }
    },

    [SET_AUTH](state, user) {
        state.isAuthenticated = true
        state.user = user
        state.errors = {}

        if (state.user.rol === '1') {
            state.user.admin = true
        }
    },
    [SET_USER_ACCESS](state, user) {
        user.access_components ? state.userAccessPlugins = JSON.parse(user.access_components) : state.userAccessPlugins = []
        user.access_tables ? state.userAccessTables = JSON.parse(user.access_tables) : state.userAccessTables = []
        state.userGestorUsuarios = user.gestor_usuarios
        state.errors = {}
    },
    [PURGE_AUTH](state) {
        state.isAuthenticated = false
        state.user = {}
        state.errors = {}
        JwtService.destroyToken()
        localStorage.removeItem('user')
        localStorage.removeItem('token')
    }
}

const actions = {
    [RECOVERY_PASS](context, email) {
        return ApiService.post('recoverypassback', email)
    },
    [LOGIN](context, credentials) {
        return new Promise((resolve) => {
            ApiService
                .post('auth', credentials)
                .then(({
                    data
                }) => {
                    context.commit(SET_LOCALSTORE, data.token)
                    resolve(data)
                })
                .catch(({
                    response
                }) => {
                    context.commit(SET_ERROR, response.data.response)
                    resolve(response.data.response)
                })
        })
    },
    [FECTH_AUTH](context, data) {
        context.commit(SET_AUTH, data)
    },
    [LOGOUT](context) {
        context.commit(PURGE_AUTH)
    },
    [CHECK_AUTH](context) {
        if (JwtService.getToken()) {
            ApiService.setHeader()
        } else {
            context.commit(PURGE_AUTH)
        }
    },
    [CHECK_TMP_RECOVERY_TOKEN](context, token) {

        return ApiService.post('check_recovery_token', token)
    },
    async [FECTH_USER_ACCESS](context, id) {
        await ApiService.post("admin/user-access", {
            token: localStorage.getItem("token"),
            project: localStorage.getItem("table"),
            id: id
        }).then(response => {
            context.commit(SET_USER_ACCESS, response.data)
        })
    }
}

export default {
    state,
    mutations,
    getters,
    actions
}



// WEBPACK FOOTER //
// ./src/store/modules/auth.js